import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/authConfig";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
msalInstance.initialize().then(() => {
  const container = document.getElementById('root');
  const root = createRoot(container!);

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
}).catch(error => {
  console.error('MSAL initialization failed:', error);
  // Fallback without MSAL
  const container = document.getElementById('root');
  const root = createRoot(container!);
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
